import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useScopedSelector } from 'ia-react-core';
import { Notification } from '../../../interfaces/Notification';
import ActionRequiredLinks from './ActionRequiredLinks';
import OnlineTransactionLinks from './OnlineTransactionLinks';
import { StyledTile } from './Content.styles';
import { OnlineTransactionResourceInfo } from '../../OnlineTransactionResource/OnlineTransactionResource';
import { ActionRequiredResourceInfo } from '../../ActionRequiredResource/ActionRequiredResource';

export interface ContentProps { }

const Content: FC<ContentProps> = () => {
  const { t } = useTranslation('ActionRequiredTile');
  const actionsRequired: Notification[] = useScopedSelector(ActionRequiredResourceInfo.dataDst);
  const onlineTransactions: Notification[] = useScopedSelector(OnlineTransactionResourceInfo.dataDst);

  if (((actionsRequired?.length ?? 0) === 0) && ((onlineTransactions?.length ?? 0) === 0)) {
    return null;
  }

  return (
    <StyledTile data-testid="actionRequiredBox" title={t('title')}>
      <ActionRequiredLinks actionsRequired={actionsRequired} />
      <OnlineTransactionLinks onlineTransactions={onlineTransactions} />
    </StyledTile>
  );
};

export default Content;
